<svelte:options tag="fds-slider" />
<script>
    import { createEventDispatcher } from "svelte";
    import { get_current_component } from "svelte/internal";
    export let rangeInput;
    export let min;
    export let max;
    export let step;
    export let value;
    export let name;
    let host = get_current_component();


    let svelteDispatch = createEventDispatcher();

    const dispatch = (name, detail) => {
        svelteDispatch(name, detail);
        host.dispatchEvent &&
        host.dispatchEvent(new CustomEvent(name, { detail }));
    };


    function handleChange(e) {
        dispatch("change", {
            value: value, //passing argument
        });
    }

    function handleInput(e) {
        dispatch("input", {
            value: value, //passing argument
        });
    }

</script>

<input bind:this={rangeInput} name="{name}" type="range" id="range" min={min} max={max} step={step}  bind:value on:input={handleInput} on:change={handleChange}  on:click>

<style>

    input[type="range"] {
        -webkit-appearance: none;
        /* width: 100%;*/
        margin: 10px 0;
    }
    input[type="range"]:focus {
        outline: none;
    }
    input[type="range"]::-webkit-slider-runnable-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        animate: 0.2s;
        background: var(--slider-track-bgcolor);
        border-radius: 1.3px;
        border: 1px solid  var(--slider-track-border-color);
    }

    input[type="range"]:focus::-webkit-slider-runnable-track {
        background: var(--slider-track-focus-bgcolor);
    }


    input[type="range"]::-webkit-slider-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid var(--slider-track-border-color);
        height: 10px;
        width: 14px;
        border-radius: 3px;
        background: var( --slider-thumb-color);
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: 0px;
        /* Add the following styles to create an arrow shape */
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }


    input[type="range"]::-moz-range-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        animate: 0.2s;
        background: var(--slider-track-bgcolor);
        border-radius: 1.3px;
        border: 1px solid  var(--slider-track-border-color);
    }

    input[type="range"]:focus::-moz-range-track{
        background: var(--slider-track-focus-bgcolor);
    }


    input[type="range"]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid var(--slider-track-border-color);
        height: 10px;
        width: 14px;
        border-radius: 3px;
        background: var( --slider-thumb-color);
        cursor: pointer;
        -moz-appearance: none;
        margin-top: 0px;
        /* Add the following styles to create an arrow shape */
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }
</style>